/* Afroyla FALL CLEARANCE — cart module for the Horizon theme. Clone of skullette-spooky-horizon-cart.js (Skullette
 * file stays frozen). ES MODULE (<script type="module">): Shopify's asset minifier rewrites dynamic import() in
 * classic scripts to require(). Exposes window.AFCCart.add({ items }) → Promise<cart>. Dispatches
 * CartLinesUpdateEvent BEFORE the fetch so cart-drawer-component auto-opens and cart-icon/cart-items update
 * exactly like a PDP add. Flow = Horizon product-form: POST /cart/add.js (+ sections) → GET /cart.js → resolve
 * the event with that cart. The GET is REQUIRED: createCartFromAjaxResponse needs a full cart (currency etc). */
import { CartLinesUpdateEvent } from '@shopify/events';

function getCart() {
  return fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } }).then((r) => r.json());
}

async function add({ items }) {
  const source = document.querySelector('[data-afc]') || document.body;
  const itemCount = items.reduce((s, it) => s + it.quantity, 0);
  const ids = [...document.querySelectorAll('cart-items-component')].map((el) => el.dataset.sectionId).filter(Boolean);
  const body = { items };
  if (ids.length) body.sections = ids.join(',');

  const deferred = CartLinesUpdateEvent.createPromise();
  source.dispatchEvent(new CartLinesUpdateEvent({
    action: 'add', context: 'product', promise: deferred.promise,
    lines: items.map((it) => ({ merchandiseId: String(it.id), quantity: it.quantity })),
  }));

  try {
    const r = await fetch('/cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) });
    const res = await r.json();
    if (!r.ok || res.status) throw new Error(res.description || res.message || `cart/add ${r.status}`);
    const cart = await getCart();
    deferred.resolve({ cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart), detail: { items: cart.items, sections: res.sections || null, itemCount, source: 'afroyla-fall-clearance', didError: false } });
    return cart;
  } catch (e) {
    getCart()
      .then((cart) => deferred.resolve({ cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart), detail: { items: cart.items, itemCount: 0, source: 'afroyla-fall-clearance', didError: true } }))
      .catch(() => deferred.reject(e));
    throw e;
  }
}

window.AFCCart = { add };
